/*
    © 2022 KondaSoft.com. All rights reserved.
    https://www.kondasoft.com
*/

// Aborts the request still in flight so rapid filter changes don't stack up
// multiple full-page fetches + DOMParser passes on the main thread.
let collectionFetchController = null

// Load Collection Contents via ajax
const loadCollectionContents = async (url = window.location.href) => {
    const $productList = document.querySelector('#collection-main-col .product-list')
    if ($productList) { $productList.style.opacity = 0.25 }

    // Cancel any request still in flight — only the latest filter state matters.
    if (collectionFetchController) { collectionFetchController.abort() }
    collectionFetchController = new AbortController()

    let data
    try {
        const response = await fetch(url, { signal: collectionFetchController.signal })
        data = await response.text()
    } catch (err) {
        if (err.name === 'AbortError') { return } // superseded by a newer request
        if ($productList) { $productList.style.opacity = 1 }
        console.error('Collection filter load failed:', err)
        return
    }

    const parser = new DOMParser()
    const newDocument = parser.parseFromString(data, 'text/html')

    document.querySelector('#collection-cols').replaceWith(newDocument.querySelector('#collection-cols'))
    document.querySelector('#collection-utilities').replaceWith(newDocument.querySelector('#collection-utilities'))
    document.querySelector('#offcanvas-collection-filters-form').replaceWith(newDocument.querySelector('#offcanvas-collection-filters-form'))
    document.querySelector('#offcanvas-collections-filters-footer').replaceWith(newDocument.querySelector('#offcanvas-collections-filters-footer'))

    initAjaxinate()
    // fixCollectionSidebarStickyPos()

    const event = new Event('initWishlist')
    document.dispatchEvent(event)

    window.history.replaceState({}, '', url)
    // Scroll-to-top removed: filter / sort / clear changes keep the user
    // exactly where they were so the products stay in view (no jump to page top).
}

// Collection sort by
window.onChangeSortBy = (value) => {
    const params = new URLSearchParams(window.location.search)
    params.set('sort_by', value)
    const url = `${window.location.pathname}?${params.toString()}`

    loadCollectionContents(url)
}

// Debounce helper — coalesces a burst of calls into a single trailing call.
const debounce = (fn, wait = 300) => {
    let timer
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => fn(...args), wait)
    }
}

// One debounced loader shared by every filter input: picking several filters
// quickly fires a single request once the user pauses, instead of one per click.
const debouncedFilterLoad = debounce(($form) => {
    const params = new URLSearchParams(new FormData($form))
    const url = `${window.location.pathname}?${params.toString()}`
    loadCollectionContents(url)
}, 300)

// Collection filters form — event delegation on document so a single listener
// survives every AJAX DOM swap (no per-checkbox re-binding after each load).
document.addEventListener('change', (e) => {
    const $filter = e.target.closest && e.target.closest('.collection-filter')
    if (!$filter) { return }
    const $form = $filter.closest('form')
    if (!$form) { return }

    // Immediate visual feedback; the actual fetch is debounced.
    const $productList = document.querySelector('#collection-main-col .product-list')
    if ($productList) { $productList.style.opacity = 0.25 }

    debouncedFilterLoad($form)
})

// Clear Collection Filters
window.clearCollectionFilters = () => {
    document.querySelectorAll('.collection-filters-form').forEach(($form) => {
        $form.style.opacity = 0.25
    })

    const params = new URLSearchParams(window.location.search)

    for (const [key] of Array.from(params)) {
        if (key !== 'sort_by') {
            params.delete(key)
        }
    }
    const url = `${window.location.pathname}?${params.toString()}`

    loadCollectionContents(url)
}

// Collection Infinite Scrolling (Ajaxinate)
const initAjaxinate = () => {
    if (document.querySelector('#AjaxinatePagination')) {
        // eslint-disable-next-line no-unused-vars
        const ajaxinate = new Ajaxinate({
            pagination: '#AjaxinatePagination',
            container: '#AjaxinateContainer',
            method: 'click',
            loadingText: 'Loading...',
            callback: () => {
                const event = new Event('initWishlist')
                document.dispatchEvent(event)
            }
        })
    }
}
initAjaxinate()

// Fix sticky position for filters sidebar
// const fixCollectionSidebarStickyPos = () => {
//     const el = document.querySelector('#collection-filters-col .sticky-top')
//     if (el) {
//         const init = () => {
//             const headerHeight = document.querySelector('#shopify-section-header.sticky-top')?.clientHeight || 0
//             el.style.top = `${headerHeight + 20}px`
//             el.style.zIndex = '1019'
//             el.style.maxHeight = `calc(100vh - ${headerHeight + 40}px)`
//             el.style.overflow = 'auto'
//         }
//         init()

//         window.addEventListener('scroll', () => {
//             if (window.scrollY > 20) {
//                 init()
//             }
//         })
//     }
// }
// fixCollectionSidebarStickyPos()
